import {RootState} from 'redux/rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const projectAnalyticsStatus = createSelector(
  [(state: RootState) => state.projectAnalytics.isLoading],
  isLoading => isLoading,
);
export const projectAnalyticsFaliure = createSelector(
  [(state: RootState) => state.projectAnalytics.errorProjectAnalyticsState],
  errorProjectAnalyticsState => errorProjectAnalyticsState,
);
export const projectAnalyticsSuccess = createSelector(
  [(state: RootState) => state.projectAnalytics.successProjectAnalyticsState],
  successProjectAnalyticsState => successProjectAnalyticsState,
);
export const projectAnalyticsDashboard = createSelector(
  [(state: RootState) => state.projectAnalytics.status],
  status => status,
);
export const projectPermissions = createSelector(
  [(state: RootState) => state.projectAnalytics.permissions],
  permissions => permissions,
);
